import { render } from "./Documente.vue?vue&type=template&id=0279213a&scoped=true&ts=true"
import script from "./Documente.vue?vue&type=script&lang=ts"
export * from "./Documente.vue?vue&type=script&lang=ts"

import "./Documente.vue?vue&type=style&index=0&id=0279213a&scoped=true&lang=css"
import "./Documente.vue?vue&type=style&index=1&id=0279213a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0279213a"]])

export default __exports__